import React, { useEffect, useState, useRef } from 'react';
import CustomSelect from 'app/components/CustomSelect';
import { Box, Button, Divider, FormControl, IconButton, Typography, Dialog, DialogTitle } from '@mui/material';
import CustomInput from 'app/components/CustomInput';
import CustomSwitch from 'app/components/CustomSwitch';
import logger from 'app/utils/logger';
import BankCodeIcon from 'app/components/Icons/BankCodeIcon';
import {
  closeBtn,
  dialogContent,
  dialogContentBoxes,
  dialogTitle,
  paperProps,
} from 'app/components/RequisiteModal/RequisiteModal.sx';
import CloseIcon from 'app/components/Icons/CloseIcon';
import DialogContent from '@mui/material/DialogContent';
import SearchIcon from 'app/components/Icons/SearchIcon';
import BankDataModal from 'app/components/AccordionTypes/Country/BankDataModal';
import FieldError from 'app/components/FieldError';
import { Simulate } from 'react-dom/test-utils';
import { useOutletContext } from 'react-router-dom';

interface Props {
  countryDetails?: any;
  value?: any;
  change?: any;
  control?: any;
  register?: any;
  handleChangeCustomerType?: any;
  customerType?: any;
  onChangeToAccount?: any;
  bankCodeLocalTransferOpen?: any;
  bankCodeLocalTransferSet?: any;
  localTransferBankData?: any;
  getBankCodeData?: any;
  transferData?: any;
  clickLocalTransferBankCode?: any;
  handleSearchLocalTransferBankCode?: any;
  setIsSearch?: any;
  errors?: any;
  selfPayment?: any;
  switchSelf?: any;
  ipsValue?: any;
  handleChangeIps?: any;
  dataIps?: any;
  handleSearch?: any;
  dataForm?: any;
  bankCodeValueLocal?: any;
  beneficiarData?: any;
  voenLocal?: any;
  beneficiarIbanLocal?: any;
  beneficiarNameLocal?: any;
  handleChangeBeneficiarIbanLocal?: any;
  handleChangeVoenLocal?: any;
  handleChangeBeneficiarNameLocal?: any;
}

const GeneralDetailsCountry = (props: Props) => {
  const {
    countryDetails,
    value,
    change,
    control,
    register,
    handleChangeCustomerType,
    customerType,
    onChangeToAccount,
    bankCodeLocalTransferOpen,
    bankCodeLocalTransferSet,
    localTransferBankData,
    getBankCodeData,
    transferData,
    clickLocalTransferBankCode,
    setIsSearch,
    errors,
    selfPayment,
    switchSelf,
    ipsValue,
    handleChangeIps,
    dataIps,
    handleSearch,
    dataForm,
    bankCodeValueLocal,
    beneficiarData,
    voenLocal,
    beneficiarNameLocal,
    handleChangeBeneficiarNameLocal,
    handleChangeBeneficiarIbanLocal,
    handleChangeVoenLocal,
    beneficiarIbanLocal,
    handleSearchLocalTransferBankCode,
  } = props;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      <Box
        sx={{
          display: 'flex',
          gap: '28px',
          width: '100%',

          '@media screen and (max-width: 768px)': {
            flexDirection: 'column',
            width: '100%',
          },
        }}
      >
        <FormControl
          sx={{
            width: 'fit-content',
            '@media screen and (max-width: 1100px)': {
              width: 'calc((100% - 28px) / 2)',
            },

            '@media screen and (max-width: 768px)': {
              width: '100%',
            },
          }}
        >
          <CustomSelect
            title={'Ödəniş prosesi növü'}
            placeholder={'Ödəniş prosesi növü'}
            options={countryDetails}
            value={value}
            rest={{ ...register('paymentType') }}
            control={control}
            onChange={change}
            isValid={errors?.paymentType !== undefined}
          />
          <FieldError error={errors.paymentType} />
        </FormControl>
        {(value?.value === 'AZIPS' || value?.value === 'XOHKS') && (
          <FormControl
            sx={{
              width: 'fit-content',
              '@media screen and (max-width: 1100px)': {
                width: 'calc((100% - 28px) / 2)',
              },

              '@media screen and (max-width: 768px)': {
                width: '100%',
              },
            }}
          >
            <CustomSelect
              title={'Müştəri tipi'}
              placeholder={'Müştəri tipi'}
              options={value?.customerType}
              control={control}
              value={customerType}
              onChange={handleChangeCustomerType}
              rest={{ ...register('customerType') }}
              optionLabel={true}
              optionValue={true}
              valueOption={'id'}
              labelOption={'title'}
              isValid={errors.customerType !== undefined}
              disabled={selfPayment}
            />
            <FieldError error={errors.customerType} />
          </FormControl>
        )}
      </Box>
      {(value?.value === 'AZIPS' || value?.value === 'XOHKS') && (
        <>
          <Box
            sx={{
              display: 'flex',
              gap: '28px',
              width: '100%',

              '@media screen and (max-width: 768px)': {
                flexDirection: 'column',
                width: '100%',
              },
            }}
          >
            <FormControl
              sx={{
                width: 'fit-content',
                '@media screen and (max-width: 1100px)': {
                  width: 'calc((100% - 28px) / 2)',
                },

                '@media screen and (max-width: 768px)': {
                  width: '100%',
                },
              }}
            >
              <CustomInput
                title={'Benefsiar bankın kodu'}
                placeholder={'Benefsiar bankın kodu'}
                adornment={
                  <IconButton onClick={() => bankCodeLocalTransferSet(true)}>
                    <BankCodeIcon />
                  </IconButton>
                }
                handleChange={onChangeToAccount}
                rest={{ ...register('bankCode'), maxLength: 6 }}
                isValid={
                  errors.bankCode !== undefined ||
                  dataForm?.error?.fields.bank_code !== undefined ||
                  beneficiarData?.error?.fields.bank_code !== undefined
                }
                value={bankCodeValueLocal}
              />
              <FieldError
                error={
                  errors.bankCode
                    ? errors.bankCode
                    : dataForm?.error?.fields.bank_code
                    ? { message: dataForm?.error?.fields.bank_code }
                    : beneficiarData?.error?.fields.bank_code && { message: beneficiarData?.error?.fields.bank_code }
                }
              />
            </FormControl>
            <FormControl
              sx={{
                width: 'fit-content',
                '@media screen and (max-width: 1100px)': {
                  width: 'calc((100% - 28px) / 2)',
                },

                '@media screen and (max-width: 768px)': {
                  width: '100%',
                },
              }}
            >
              <CustomInput
                title={'Benefsiar bankın adı'}
                placeholder={'Benefsiar bankın adı'}
                disabled={true}
                rest={{ ...register('bankName') }}
              />
            </FormControl>
          </Box>
          <Box
            sx={{
              display: 'flex',
              gap: '28px',
              width: '100%',

              '@media screen and (max-width: 768px)': {
                flexDirection: 'column',
                width: '100%',
              },
            }}
          >
            <FormControl
              sx={{
                width: 'fit-content',
                '@media screen and (max-width: 1100px)': {
                  width: 'calc((100% - 28px) / 2)',
                },

                '@media screen and (max-width: 768px)': {
                  width: '100%',
                },
              }}
            >
              <CustomInput
                title={'Benefsiar bankın hesab nömrəsi'}
                placeholder={'Benefsiar bankın hesab nömrəsi'}
                disabled={true}
                rest={{ ...register('bankAccNumber') }}
              />
            </FormControl>
          </Box>
          <CustomSwitch
            title={'"Özünə" ödəniş'}
            rest={{ ...register('self') }}
            handleToggle={switchSelf}
            checked={selfPayment}
          />
          <Box
            sx={{
              display: 'flex',
              gap: '28px',
              flexWrap: 'wrap',
              width: '100%',

              '@media screen and (max-width: 768px)': {
                flexDirection: 'column',
                width: '100%',
              },
            }}
          >
            {(customerType === null || customerType === undefined || customerType.type !== '1') && (
              <FormControl
                sx={{
                  width: 'fit-content',
                  '@media screen and (max-width: 1100px)': {
                    width: 'calc((100% - 28px) / 2)',
                  },

                  '@media screen and (max-width: 768px)': {
                    width: '100%',
                  },
                }}
              >
                <CustomInput
                  title={'Benefsiarın VÖEN-i'}
                  placeholder={'Benefsiarın VÖEN-i'}
                  rest={{ ...register('beneficiarVoen'), maxLength: 10 }}
                  isValid={errors.beneficiarVoen !== undefined || dataForm?.error?.fields.cr_tax_no !== undefined}
                  disabled={selfPayment}
                  handleChange={handleChangeVoenLocal}
                  value={voenLocal}
                />
                <FieldError
                  error={
                    errors.beneficiarVoen
                      ? errors.beneficiarVoen
                      : dataForm?.error?.fields.cr_tax_no && { message: dataForm?.error?.fields.cr_tax_no }
                  }
                />
              </FormControl>
            )}

            <FormControl
              sx={{
                width: 'fit-content',
                '@media screen and (max-width: 1100px)': {
                  width: 'calc((100% - 28px) / 2)',
                },

                '@media screen and (max-width: 768px)': {
                  width: '100%',
                },
              }}
            >
              <CustomInput
                title={'Benefsiarın adı'}
                placeholder={'Benefsiarın adı'}
                rest={{ ...register('beneficiarName'), maxLength: 34 }}
                isValid={errors.beneficiarName !== undefined || dataForm?.error?.fields.cr_name !== undefined}
                disabled={selfPayment}
                handleChange={handleChangeBeneficiarNameLocal}
                value={beneficiarNameLocal}
              />
              <FieldError
                error={
                  errors.beneficiarName
                    ? errors.beneficiarName
                    : dataForm?.error?.fields.cr_name && { message: dataForm?.error?.fields.cr_name }
                }
              />
            </FormControl>

            <FormControl
              sx={{
                width: 'fit-content',
                '@media screen and (max-width: 1100px)': {
                  width: 'calc((100% - 28px) / 2)',
                },

                '@media screen and (max-width: 768px)': {
                  width: '100%',
                },
              }}
            >
              <CustomInput
                title={'Benefsiarın hesab nömrəsi'}
                placeholder={'Benefsiarın hesab nömrəsi'}
                rest={{ ...register('beneficiarAccNo'), maxLength: 28 }}
                isValid={errors.beneficiarAccNo !== undefined || dataForm?.error?.fields.cr_acc_no !== undefined}
                handleChange={handleChangeBeneficiarIbanLocal}
                value={beneficiarIbanLocal}
              />
              <FieldError
                error={
                  errors.beneficiarAccNo
                    ? errors.beneficiarAccNo
                    : dataForm?.error?.fields.cr_acc_no && { message: dataForm?.error?.fields.cr_acc_no }
                }
              />
            </FormControl>
          </Box>
          {bankCodeLocalTransferOpen && (
            <BankDataModal
              getCodeData={getBankCodeData}
              codeData={localTransferBankData}
              dialogOpen={bankCodeLocalTransferOpen}
              dialogSet={bankCodeLocalTransferSet}
              transferData={transferData}
              clickCode={clickLocalTransferBankCode}
              setIsSearch={setIsSearch}
            />
          )}
        </>
      )}
      {value?.value === 'IPS_MT' && (
        <>
          <Box
            sx={{
              display: 'flex',
              gap: '28px',
              width: '100%',

              '@media screen and (max-width: 768px)': {
                flexDirection: 'column',
                width: '100%',
              },
            }}
          >
            <FormControl>
              <CustomSelect
                title={'IPS Alias növü'}
                placeholder={'IPS Alias növü'}
                options={value?.customerType}
                rest={{ ...register('ipsType') }}
                control={control}
                value={customerType}
                onChange={handleChangeCustomerType}
                optionLabel={true}
                optionValue={true}
                valueOption={'code'}
                labelOption={'title'}
                isValid={errors.ipsType !== undefined}
              />
              <FieldError error={errors.ipsType} />
            </FormControl>
            <FormControl>
              <CustomInput
                title={'IPS Alias dəyər'}
                placeholder={'IPS Alias dəyər'}
                rest={{ ...register('ipsValue') }}
                isValid={errors.ipsValue !== undefined || dataIps?.error !== undefined || dataForm?.error !== undefined}
                sx={{
                  '&.MuiInputBase-root': {
                    paddingRight: '8px !important',
                  },
                }}
                handleChange={handleChangeIps}
                adornment={
                  ipsValue?.length > 0 && (
                    <Button
                      color="secondary"
                      sx={{ height: '32px', fontSize: '12px !important', fontWeight: '600', minWidth: '48px' }}
                      onClick={handleSearch}
                    >
                      Axtar
                    </Button>
                  )
                }
              />
              <FieldError
                error={
                  errors.ipsValue
                    ? errors.ipsValue
                    : dataIps?.error.text
                    ? { message: dataIps?.error.text }
                    : dataForm?.error?.text && { message: dataForm?.error?.text }
                }
              />
            </FormControl>
          </Box>
          {dataIps !== undefined &&
          dataIps?.result !== 'error' &&
          customerType !== null &&
          customerType.code !== 'IBAN' ? (
            <>
              <Box sx={{ display: 'flex', gap: '28px' }}>
                <CustomInput
                  title={'Benefsiar bankın adı'}
                  placeholder={'Benefsiar bankın adı'}
                  disabled={true}
                  rest={{ ...register('bankName') }}
                />
                <CustomInput
                  title={'Benefsiar bankın hesab nömrəsi'}
                  placeholder={'Benefsiar bankın hesab nömrəsi'}
                  disabled={true}
                  rest={{ ...register('bankAccNumber') }}
                />
              </Box>
              <Box sx={{ display: 'flex', gap: '28px' }}>
                <CustomInput
                  title={'Benefsiarın VÖEN-i'}
                  placeholder={'Benefsiarın VÖEN-i'}
                  rest={{ ...register('beneficiarVoen') }}
                  disabled={true}
                />
                <CustomInput
                  title={'Benefsiarın adı'}
                  placeholder={'Benefsiarın adı'}
                  rest={{ ...register('beneficiarName') }}
                  disabled={true}
                />
              </Box>
              <Box sx={{ display: 'flex', gap: '28px' }}>
                <CustomInput
                  title={'Benefsiarın hesab nömrəsi'}
                  placeholder={'Benefsiarın hesab nömrəsi'}
                  rest={{ ...register('beneficiarAccNo') }}
                  disabled={true}
                />
              </Box>
            </>
          ) : dataIps !== undefined && customerType !== null && customerType.code === 'IBAN' ? (
            <>
              <Box sx={{ display: 'flex', gap: '28px' }}>
                <FormControl>
                  <CustomInput
                    title={'Benefsiar bankın kodu'}
                    placeholder={'Benefsiar bankın kodu'}
                    adornment={
                      <IconButton onClick={() => bankCodeLocalTransferSet(true)}>
                        <BankCodeIcon />
                      </IconButton>
                    }
                    handleChange={onChangeToAccount}
                    rest={{ ...register('bankCode') }}
                    isValid={errors.bankCode !== undefined}
                  />
                  <FieldError error={errors.bankCode} />
                </FormControl>
              </Box>
              <Box sx={{ display: 'flex', gap: '28px' }}>
                <FormControl>
                  <CustomInput
                    title={'Benefsiarın VÖEN-i'}
                    placeholder={'Benefsiarın VÖEN-i'}
                    rest={{ ...register('beneficiarVoen'), maxLength: 10 }}
                    isValid={errors.beneficiarVoen !== undefined || dataForm?.error !== undefined}
                  />
                  <FieldError
                    error={
                      errors.beneficiarVoen
                        ? errors.beneficiarVoen
                        : dataForm?.error?.fields.cr_tax_no && { message: dataForm?.error?.fields.cr_tax_no }
                    }
                  />
                </FormControl>
                <FormControl>
                  <CustomInput
                    title={'Benefsiarın adı'}
                    placeholder={'Benefsiarın adı'}
                    rest={{ ...register('beneficiarName') }}
                    isValid={errors.beneficiarName !== undefined || dataForm?.error !== undefined}
                  />
                  <FieldError
                    error={
                      errors.beneficiarName
                        ? errors.beneficiarName
                        : dataForm?.error?.fields.cr_name && { message: dataForm?.error?.fields.cr_name }
                    }
                  />
                </FormControl>
              </Box>
              <FormControl>
                <CustomInput
                  title={'Benefsiarın hesab nömrəsi'}
                  placeholder={'Benefsiarın hesab nömrəsi'}
                  rest={{ ...register('beneficiarAccNo') }}
                  isValid={errors.beneficiarAccNo !== undefined || dataForm?.error !== undefined}
                />
                <FieldError
                  error={
                    errors.beneficiarAccNo
                      ? errors.beneficiarAccNo
                      : dataForm?.error?.fields.cr_acc_no && { message: dataForm?.error?.fields.cr_acc_no }
                  }
                />
              </FormControl>
            </>
          ) : null}
        </>
      )}
    </Box>
  );
};

export default GeneralDetailsCountry;
